import { Helmet } from "react-helmet-async";

const SITE_URL = "https://shineoncoin.com";
const DEFAULT_TITLE = "Shine on Coin — Personalized Gold & Silver Engravings";
const DEFAULT_DESCRIPTION =
  "Shine on Coin hand-engraves 99.9 silver coins, gold lockets & bracelets with your photograph. Custom gifts for weddings, anniversaries & corporate gifting, made in Hyderabad.";
const DEFAULT_IMAGE =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/t5ysjhxf_ChatGPT%20Image%20Aug%206%2C%202026%2C%2003_04_37%20AM.png";

/**
 * Injects page-specific SEO tags — <title>, meta description, canonical, Open Graph and Twitter card.
 *
 * @param {string}  title       Page title (site suffix is appended automatically)
 * @param {string}  description Meta description (150–160 chars ideal)
 * @param {string}  path        Current route path e.g. "/catalog"
 * @param {string}  image       Absolute image URL for social sharing
 * @param {string}  type        Open Graph type — "website" (default) or "product"
 */
export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  jsonLd = [],
}) {
  const fullTitle = title
    ? title.includes("Shine on Coin") || title.includes("ShineOnCoin")
      ? title
      : `${title} | Shine on Coin`
    : DEFAULT_TITLE;
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />

      {jsonLd.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}

      {/* Open Graph */}
      <meta property="og:site_name" content="Shine on Coin" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Business */}
      <meta name="geo.region" content="IN-TG" />
      <meta name="geo.placename" content="Hyderabad" />
    </Helmet>
  );
}
